import React from 'react';
import { Section } from './ui/Section';
export function OpeningLead() {
  return <Section background="white" data-id="element-74">
      <div className="prose prose-lg mx-auto text-[#2C2C2C]" data-id="element-75">
        <p className="text-2xl font-medium leading-relaxed mb-8" data-id="element-76">
          Hay un tipo de cansancio que no se arregla con "échale ganas".
        </p>

        <p className="mb-6" data-id="element-77">
          Es el cansancio de hacer lo correcto y sentir que tu cuerpo igual te
          lleva la contraria.
        </p>

        <p className="mb-6" data-id="element-78">Te cuidas. Trabajas. Resuelves.</p>

        <p className="mb-6" data-id="element-79">
          Y aun así… a cierta hora del día te inflamas, te da hambre rara, y en
          la noche aparece el impulso:{' '}
          <span className="italic" data-id="element-80">"solo hoy"</span>.
        </p>

        <p className="mb-6" data-id="element-81">
          Si tienes 35+ y últimamente piensas "yo antes podía"… no estás
          imaginando nada.
        </p>

        <p className="font-semibold text-[#D4735E] text-xl mb-8" data-id="element-82">
          Lo que cambió no fue tu disciplina. Cambió el tablero.
        </p>

        <div className="bg-[#FFF8F0] p-8 rounded-xl border-l-4 border-[#D4735E]" data-id="element-83">
          <p className="font-bold text-lg mb-2" data-id="element-84">Esto no es otra dieta.</p>
          <p data-id="element-85">
            Es un sistema mínimo para recuperar control cuando tu energía ya no
            da para planes perfectos.
          </p>
        </div>
      </div>
    </Section>;
}